/* Core & libraries */
import React, {useCallback, useMemo} from "react";
import {useTheme} from "react-jss";
import {defineMessages, FormattedMessage, useIntl} from "react-intl";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import {ReactComponent as HourGlassSvg} from "resources/images/hourglass.svg";
import {ReactComponent as CloseIconCircle} from "resources/images/circled-x.svg";
import {ReactComponent as CompleteIconCircle} from "resources/images/complete-icon-circle.svg";
import UCButton from "components/buttons";
import UCAutocomplete from "components/ucautocomplete";
import LoyaltyDeleteAllFailedModal from "../../modals/loyaltyDeleteAllFailedModal";
import {ReactComponent as CloseIcon} from "resources/images/close-icon-20.svg";

/* Styles */
import styles from "./styles.js"
import FilterMenuSelect from "components/redemptionHistory/FilterMenuSelect";

const messages = defineMessages({
  searchPlaceholder: {
    id: "redemptionHistory.grid.header.search",
  },
});

export const REDEMPTION_HISTORY_GRID_TYPE = {
  PENDING: 'PENDING',
  FAILED: 'FAILED',
  COMPLETED: 'COMPLETE'
}
const RedemptionHistoryFilters = (props) => {
  const {gridOptions, setGridOptions, gridData, getLoyaltyList, failureCount, allotmentBudgetYear} = props;
  const theme = useTheme();
  const classes = styles({theme});

  const applyFilters = useCallback((filters) => {
    setGridOptions(gridOptions => ({
      ...gridOptions,
      ...filters,
      filters: {
        ...gridOptions.filters,
        ...filters?.filters,
      }
    }));
  }, []);

  const setGridType = useCallback((type) => () => {
    applyFilters({page: 1, type})
    if (typeof getLoyaltyList === 'function') getLoyaltyList();
  }, []);

  const setGridSearchTerm = useCallback((searchterm = undefined) => {
    applyFilters({page: 1, searchterm})
  }, []);

  const intl = useIntl();

  const currentFilterMenuOption = useMemo(() => allotmentBudgetYear?.find(option => option.value === `${gridOptions?.filters?.ALLOTMENTTYPE}-${gridOptions?.filters?.BUDGETYEAR}`), [gridOptions?.filters?.ALLOTMENTTYPE, gridOptions?.filters?.BUDGETYEAR]);


  return (<>
    <div className={classes.filters}>
      <div className={classes.filterContainer}>
        <div className={classes.filterButtons}>
          <div className={classes.filterGroups}>
            <UCButton
              onClick={setGridType(REDEMPTION_HISTORY_GRID_TYPE.COMPLETED)}
              type="default"
              className={`${classes.filter} ${gridOptions?.type === REDEMPTION_HISTORY_GRID_TYPE.COMPLETED ? classes.active : ""}`}
              text={<FormattedMessage id="redemptionHistory.grid.header.filters.completed"/>}
              icon={<CompleteIconCircle/>}
            />
           {failureCount > 0 ? <UCButton
              onClick={setGridType(REDEMPTION_HISTORY_GRID_TYPE.FAILED)}
              type="default"
              className={`${classes.filter} ${gridOptions?.type === REDEMPTION_HISTORY_GRID_TYPE.FAILED ? classes.active : ""}`}
              text={<FormattedMessage id="redemptionHistory.grid.header.filters.failed"/>}
              icon={<CloseIconCircle/>}
            /> : null}
            <UCButton
              onClick={setGridType(REDEMPTION_HISTORY_GRID_TYPE.PENDING)}
              type="default"
              className={`${classes.filter} ${gridOptions?.type === REDEMPTION_HISTORY_GRID_TYPE.PENDING ? classes.active : ""}`}
              text={<FormattedMessage id="redemptionHistory.grid.header.filters.pending"/>}
              icon={<HourGlassSvg/>}
            />
          </div>
          {gridOptions?.type === REDEMPTION_HISTORY_GRID_TYPE.FAILED &&
            <LoyaltyDeleteAllFailedModal getLoyaltyList={getLoyaltyList} gridData={gridData}
                                         applyFilters={() => applyFilters({type: REDEMPTION_HISTORY_GRID_TYPE.FAILED})}/>}
        </div>
      </div>


      <div className={classes.filterMenuContainer}>
        <UCAutocomplete
          value={gridOptions?.searchterm}
          showMinError={false}
          type="REDEMPTION_HISTORY"
          className={classes.autocomplete}
          getOptions={setGridSearchTerm}
          placeholder={intl.formatMessage(messages.searchPlaceholder)}
          onClear={setGridSearchTerm}
          disabled={gridData?.dataItems.length === 0}
        />

        {gridOptions?.type === REDEMPTION_HISTORY_GRID_TYPE.COMPLETED &&
          <FilterMenuSelect
            value={gridOptions?.filters?.BUDGET}
            className={classes.roles}
            options={allotmentBudgetYear}
            onChange={(item) => {
              const [ALLOTMENTTYPE, BUDGETYEAR] = (currentFilterMenuOption?.value === item.value ? null : item.value)?.split('-') ?? [];

              setGridOptions({
                ...gridOptions,
                page: 1,
                filters: {
                  ...gridOptions.filters,
                  ALLOTMENTTYPE,
                  BUDGETYEAR,
                }
              })
            }}
            disabled={gridData?.dataItems.length === 0 && !currentFilterMenuOption}
          />}
      </div>

    </div>
    {currentFilterMenuOption ? <div className={classes.redemptionFilterContainer}>
      <UCButton
        type="secondary"
        onClick={() => setGridOptions({
          ...gridOptions,
          page: 1,
          filters: {
            ...gridOptions.filters,
            ALLOTMENTTYPE: null,
            BUDGETYEAR: null
          }
        })}
        className={classes.redemptionFilterElement}
        iconEnd={<CloseIcon/>}
      >
        {currentFilterMenuOption.label}
      </UCButton>
    </div> : null}
  </>)
}

export default RedemptionHistoryFilters;
